import { authRoutes } from './Authentication/routes';
import { communityRoutes } from './Community/routes';
import { dashboardRoutes } from './Dashboard/routes';
import { legislatorPageRoutes } from './LegislatorPage/routes';
import { settingsRoutes } from './Settings/routes';
// import { webContentEditorRoutes } from './WebContentEditor/routes';
import { homeRoutes } from './Home/routes';
import { webSupportRoutes } from './Support/routes';
import { businessEnquiryRoutes } from './BusinessEnquiry/routes';
import { integratedAppsRoutes } from './IntegratedApps/routes';
import { aiTrainingRoutes } from './AiTraining/routes';
import { aiAgentRoutes } from './AiAgents/routes';
import { marketingRoutes } from './Marketing/routes';
import { activeDataRoutes } from './Settings/components/ActiveData/routes';
import { partnersRoutes } from './Partners/routes';
import { aiAgentsFunctionsRoutes } from './AiAgentsFunctions/routes';
import { CustomersRoutes } from './Customers/routes';
import { DriveRoutes } from './Drive/routes';
import { orderRoutes } from './Order/routes';
import { cartRoutes } from './Cart/routes';
import { roomsRoutes } from './Rooms/routes';
import { jobsRoutes } from './Jobs/routes';
import { channelsRoutes } from './Channels/routes';
import { CrmRoutes } from './Crm/routes';
// import { CompanyRoutes } from './Company/routes';
import { PreferenceSettingsRoutes } from './Settings/components/AccountPreferenceSettings/routes';
import { webFeedRoutes } from './Feed/routes';
import { userRoleManagementRoutes } from './UserRoleManagement/routes';
import { partnerAssistRoutes } from './PartnerAssist/routes';
import { audiencesRoutes } from './Audiences/routes';
import { warrantyRoutes } from './Warranty/routes';
import { loyaltyAssistRoutes } from './LoyaltyAssist/routes';
import { analyticsDashboardRoutes } from './AnalyticsDashboard/routes';

export const webRoutes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...communityRoutes,
  ...settingsRoutes,
  ...aiAgentRoutes,
  ...activeDataRoutes,
  ...partnersRoutes,

  ...legislatorPageRoutes,
  // ...webContentEditorRoutes,
  ...webSupportRoutes,
  ...businessEnquiryRoutes,
  ...integratedAppsRoutes,
  ...aiTrainingRoutes,
  ...aiAgentsFunctionsRoutes,
  // TODO
  ...homeRoutes,
  ...marketingRoutes,
  ...CustomersRoutes,
  // ...CompanyRoutes,
  ...DriveRoutes,
  ...orderRoutes,
  ...cartRoutes,
  ...roomsRoutes,
  ...jobsRoutes,
  ...channelsRoutes,
  ...CrmRoutes,
  ...PreferenceSettingsRoutes,
  ...webFeedRoutes,
  ...userRoleManagementRoutes,
  ...partnerAssistRoutes,
  ...audiencesRoutes,
  ...warrantyRoutes,
  ...loyaltyAssistRoutes,
  ...analyticsDashboardRoutes,
];
